import React from 'react';
import { blur } from 'redux-form';

/**
 * HOC to handle redux-form's default onBlur updating the value
 * of an input based on its event target. In this case,
 * it addresses where you have finished typing on a keyboard input but
 * switch to another keyboard input causing the input you just wrote to be
 * inputted into the new input you have focused.
 *
 * See https://github.com/erikras/redux-form/issues/2768
 */
const withReduxFormBlur = ReduxFormInput =>
  class InputWithBlur extends React.Component {
    onBlur = e => {
      const {
        name,
        meta: { dispatch, form },
        value,
        onBlur,
        formatOnBlur,
      } = this.props;

      let inputValue = value;

      if (formatOnBlur) {
        inputValue = formatOnBlur(value);
      }

      dispatch(blur(form, name, inputValue));

      // Don't pass in the event object to prevent incorrect behavior
      onBlur();
    };

    render() {
      const { onBlur, formatOnBlur, forwardRef, ...rest } = this.props;

      return <ReduxFormInput ref={forwardRef} onBlur={this.onBlur} {...rest} />;
    }
  };

export default withReduxFormBlur;



// WEBPACK FOOTER //
// ./src/common/Components/Keyboard/withReduxFormBlur.js